var v1="<div class=\"form-group\"> <label for=\"{{ vm.settings.dataAt }}\">{{ vm.settings.displayName }}</label> <ui-select ng-model=\"vm.data\"> <ui-select-match allow-clear=\"true\" class=\"ui-select-match\"> {{ $select.selected.Title }} - {{ $select.selected.Id }} </ui-select-match> <ui-select-choices repeat=\"item.Id as item in vm.searchResults\" refresh=\"vm.refreshData($select.search)\" refresh-delay=\"300\"> <div>{{ item.Title }} - {{ item.Id }}</div> </ui-select-choices> </ui-select> <p class=\"help-block\" ng-if=\"vm.settings.helpText\">{{ vm.settings.helpText }}</p> </div>";
window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("components/lbaODataSelect/lbaODataSelect.html", v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./src/components/lbaODataSelect/lbaODataSelect.html
// module id = 373
// module chunks = 0